//src/components/apicalls/schedules.js
import axios from 'axios';
import { isAuthenticated } from './auth';
const BASE = process.env.REACT_APP_API_URL || '';

// helper to build Authorization header
function authHeader() {
  const user = isAuthenticated();
  return user?.access_token
    ? { Authorization: `Bearer ${user.access_token}` }
    : {};
}
/**
 * Fetch coach schedules with pagination.
 *
 * @param {number} perPage - Number of items per page.
 * @param {number} page - Page number.
 */
/**
 * Fetch coach schedules with pagination and optional search.
 *
 * @param {number} perPage - Number of items per page.
 * @param {number} page - Page number.
 * @param {string} [search] - Optional search term.
 */
export function fetchCoachSchedules(perPage, page, search = '') {
  const params = { perPage, page };
  if (search) params.search = search;
  return axios.get(`${BASE}/api/admin/coach-schedules`, {
    headers: authHeader(),
    params,
  });
}

export function createCoachSchedule(data) {
  return axios.post(`${BASE}/api/admin/coach-schedules`, data,{ headers: authHeader() });
}

export function updateCoachSchedule(id, data) {
  return axios.put(`${BASE}/api/admin/coach-schedules/${id}`, data,{ headers: authHeader() });
}

export function deleteCoachSchedule(id) {
  return axios.delete(`${BASE}/api/admin/coach-schedules/${id}`,{ headers: authHeader() });
}

/**
 * Fetch lessons (booked sessions) for a given date across coach schedules.
 * Example endpoint: GET /coach-schedules/lessons/:date
 * @param {string} date - date string in YYYY-MM-DD format
 */
export function fetchLessonsByDate(date) {
  return axios.get(`${BASE}/api/admin/coach-schedules/lessons/${date}`, { headers: authHeader() });
}
